<template lang="pug">
  .wrap
    h2 {{title}}
    slot
</template>
<script>
export default {
  props: {
    title: String
  }
}
</script>
<style lang="scss" scoped>
  .wrap{
    max-width: $maxwidth;
    margin: 0 auto;
    h2{
      @include fluid-type(360px,
      1440px,
      64px,
      96px);
        line-height: 120%;
        text-align: center;
        margin-bottom: 2rem;
        // text-shadow: 1px 1px 0px rgba(black, 0.9), 1px 2px 3px rgba(black, 0.2) ;
        color: white;
        font-family: 'LaTercera', sans-serif;
        text-transform: uppercase;
        letter-spacing: 1px;
        small{
          display: block;
          font-size: 3rem;
          line-height: 3rem;
        }
    }
  }
</style>


